import { CheckCircleFilled, QuestionCircleFilled, WarningFilled } from '@ant-design/icons';
import { COLOR_OPTIONS } from 'config/style';
import type { RiskLevelEnum } from 'querys/regional-overview/regional-overview.query.models';
import styled from 'styled-components';
import { getContainerBackgroundColor, getIconColor } from './risk-level-wrapper.utils';

interface StyledProps {
  $riskLevel?: RiskLevelEnum;
}

interface CollapseArrowProps {
  $isOpen: boolean;
}

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Header = styled.div<StyledProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: auto;
  padding: 0 12px;
  background-color: ${({ $riskLevel }) => getContainerBackgroundColor($riskLevel)};
  cursor: pointer;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.9;
  }
`;

export const RiskWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const CollapseArrow = styled.div<CollapseArrowProps>`
  display: flex;
  align-items: center;
  font-size: 10px;
  color: ${COLOR_OPTIONS.NEUTRAL_60};
  transition: transform 0.3s ease;
  transform: ${({ $isOpen }) => ($isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
`;

export const Content = styled.div`
  padding: 12px;
  background-color: ${COLOR_OPTIONS.NEUTRAL_00};
`;

export const WarningIcon = styled(WarningFilled)<StyledProps>`
  color: ${({ $riskLevel }) => getIconColor($riskLevel)};
  font-size: 14px;
`;

export const CheckIcon = styled(CheckCircleFilled)<StyledProps>`
  color: ${({ $riskLevel }) => getIconColor($riskLevel)};
  font-size: 14px;
`;

export const QuestionIcon = styled(QuestionCircleFilled)<StyledProps>`
  color: ${({ $riskLevel }) => getIconColor($riskLevel)};
  font-size: 14px;
`;

export const RiskLevel = styled.div`
  font-weight: 600;
  font-size: 12px;
  line-height: 20px;
  color: ${COLOR_OPTIONS.NEUTRAL_100};
`;

export const FarmCount = styled.div`
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  color: ${COLOR_OPTIONS.NEUTRAL_60};
`;
